export default __webpack_public_path__ + "static/media/monitor.26863673.png";